import { defineStore } from 'pinia'
import axios from 'axios'
import { toast } from 'vue3-toastify'
import ErrorMessage from '@/constant/ErrorMessage'
import Urls from '@/constant/Urls'
import { router } from '@/plugins/router'

export const useAuthStore = defineStore('auth', {

  state: () => ({
    email: '',
    password: '',
    remember: false,
    authStatus: !!localStorage.getItem('auth_token'),
    accountType: localStorage.getItem('accountType') as string || null,
    profileAlert: '',
    user: ref(null),
  }),
  getters: {
    isAuthenticated: state => state.authStatus,

    getProfileAlert: (state) => {
      return state.profileAlert; // Ensure it returns a string, not a Promise
    },
  },
  actions: {
    async login() {
      // const token = localStorage.getItem('auth_token')
      try {
        await axios.get('http://localhost/auth/generate/csrf-cookie', {
          withCredentials: true,
        }).catch(() => {
          toast.error(ErrorMessage.InvalidRequest)
          throw new Error('CSRF Cookie setup failed');
        })

        const postOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            email: this.email,
            password: this.password,
          }),
        }

        const loginResponse = await fetch(`${Urls.api}auth/login`, postOptions)
        if (!loginResponse.ok) {
          toast.error('Login failed. Please try again.');
          return;
        }
        const loginJson = await loginResponse.json()

        // check that the user is verified before authentication
        if (loginJson.success && loginJson.data.user.verified) {
          // Save token and account type to localStorage
          localStorage.setItem('auth_token', loginJson.data.auth_token)
          localStorage.setItem('accountType', loginJson.data.roles[0])

          this.authStatus = true
          this.accountType = loginJson.data.roles[0]

          await router.push('/dashboard')
          toast.success(loginJson.message)
        } else if (loginJson.success && !loginJson.data.user.verified) {
          // window.location.replace('verify-email')
          await router.push('/verify-email')
        } else {
          toast.error(loginJson.message)
        }
      } catch (error) {
        toast.error(ErrorMessage.InvalidRequest)
      }

      if (!localStorage.getItem('auth_token'))
        toast.error(ErrorMessage.SomethingWentWrong)
    },
    async getUserProfile() {
      const authToken = localStorage.getItem('auth_token')
      const accountType = localStorage.getItem('accountType')

      if (!authToken) {
        this.authStatus = false
        await router.push('/login')
        toast.warn('Kindly Login to Continue..')
        return
      }

      try {
        // Check user profile for verification
        const profileResponse = await fetch(`${Urls.api}profile/my-profile`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${authToken}`,
            Accept: 'application/json',
          },
        })
        const profileJson = await profileResponse.json()
        // Check profile verification status
        if (profileJson.success) {
          this.user = profileJson.data.user

          // ✅ Ensure `this.user` is defined before accessing its properties
          if (!this.user || !this.user.bio) {
            toast.error('Invalid user data received.');
            return;
          }

          if (!this.user.bio.verified || profileJson.message === 'Your email address is not verified.') {
            // Redirect for email verification
            this.authStatus = false
            toast.warn('Your email address is not verified');
            window.location.replace('verify-email')
            return
          }
          // else {
            // Redirect to Dashboard for Authenticated user
            this.authStatus = true
            this.accountType = localStorage.getItem('accountType') || this.user.role;

            //Check for incomplete profile
          const bio = this.user.bio
            if (
              bio.status != 'confirmed' ||
              bio.verified != true ||
              !bio.avatar ||
              !bio.phoneNumber ||
              !bio.residentialAddress ||
              !bio.stateOfResidence
            ) {
              this.profileAlert = 'Please complete your profile to access all features!';
            } else {
              this.profileAlert = '';
            }

            if (accountType === 'agro user') {
              await router.push('/dashboard')
            } else {
              toast.info('Unknown User Types')
            }
        }
        else {
          await this.logout()
        }
      } catch (error) {
        this.authStatus = false;
        localStorage.removeItem('auth_token');
        localStorage.removeItem('accountType');
        await router.push('/login');
        toast.error('Error fetching user profile.');
      }
    },
    async logout() {
      const authToken = localStorage.getItem('auth_token')
      localStorage.clear()
      try {
        const response = await fetch(`${Urls.api}auth/logout`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${authToken}`,
            Accept: 'application/json',
          },
        })

        const jsonDataResponse = await response.json()

        if (jsonDataResponse.message === 'Logout successful') {
          this.authStatus = false
          this.accountType = null
          localStorage.clear()
          window.location.href = '/home'
          toast.success(jsonDataResponse.message)
        } else if (jsonDataResponse.message === 'You\'re not Logged in') {
          this.authStatus = false
          this.accountType = null
          localStorage.clear()
          window.location.href = '/login'
          toast.warn('Kindly Login to Continue..')
        } else {
          toast.error('Something went wrong! Unable to Logout')
        }
      } catch (error) {
        toast.error('Something went wrong! Unable to Logout');
      }
    },
    initializeFromLocalStorage() {
      const authToken = localStorage.getItem('auth_token');
      const accountType = localStorage.getItem('accountType');

      if (authToken) {
        this.authStatus = true;
        this.accountType = accountType;
        this.getUserProfile()
      } else {
        this.authStatus = false;
        this.accountType = null;
      }
    },
    checkAuth() {
      return !!localStorage.getItem('auth_token')
    }
  }
})
